import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-weather-icon',
	templateUrl:'./WeatherIconPluginCompPage.html',
	styles: [],
	styleUrls:['./WeatherIconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WeatherIconPluginCompPage
{
	mdContent_1162 = `\`\`\`java
import com.jwebmp.plugins.weathericons.WeatherIcon;
\`\`\``;
	mdContent_1163 = `\`\`\`java
// WeatherIcon.day_sunny.toString() returns "wi-day-sunny"
\`\`\``;
}
